import React from 'react';
import css from './tags.module.scss';
import PlusIcon from '../../../../../shared/assets/images/plus.svg';
import { ITag } from '../../../private-template-module-tag/api/types';
import { ModuleTag } from '../../../private-template-module-tag/ui/module-tag';

interface ModuleTagsProps {
	tags: ITag[],
	onBindTag?: () => void,
	onUnbindTag?: (id: number) => void;
}

export const ModuleTags = ({
	tags,
	onBindTag,
	onUnbindTag,
}: ModuleTagsProps) => (
	<div className={css.tags_block}>
		{
			tags?.map(tag => (
				<ModuleTag
					key={tag.id}
					tag={tag}
					onUnbind={onUnbindTag ? () => onUnbindTag(tag.id) : undefined}
					styles={css.tag}
				/>
			))
		}
		<div
			className={css.plus}
			onClick={onBindTag}
		>
			<PlusIcon />
		</div>
	</div>
);
